import { render, staticRenderFns } from "./EditPatientModalWrapper.vue?vue&type=template&id=ad321390"
import script from "./EditPatientModalWrapper.vue?vue&type=script&lang=js"
export * from "./EditPatientModalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports